/* eslint-disable no-param-reassign */
import Backbone from 'backbone';
import _ from 'underscore';

import {
  RECOMMENDATION_TYPES,
} from '@bingads-webui-campaign/recommendation-core';
import Editor from '@bingads-webui-campaign-legacy/crud-ad/view/adEditor';
import template from './ads-editor-container.pug';
import { transformMultimediaAd, adTypeFieldsMapping } from './const';

export default class AdsEditorContainer extends Backbone.View {
  initialize({
    deps,
    i18n,
    newI18n,
    model,
    accountId,
    campaignId,
    adGroupId,
    inlineSuggestionsEnabled,
    showLightbulb,
    type,
  }) {
    this.deps = deps;
    this.i18n = i18n;

    let options = {
      model,
      accountId,
      campaignId,
      adGroupId,
      isSaveToServer: false,
      showInline: true,
      isForVNext: true,
      inlineSuggestionsEnabled,
      showLightbulb,
      newI18n,
      isRecommendation: true,
      isImproveRSA: type === RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS,
      isImproveMMA: type === RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS,
    };

    if (type === RECOMMENDATION_TYPES.MULTIMEDIA_ADS) {
      options = _.extend({}, options, { campaignType: 'Default' });
    } else if (type === RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS) {
      options = _.extend({}, options, { campaignType: 'Audience' });
    }

    const AdsEditor = Editor;
    this.adEditor = new AdsEditor(options);
  }

  hasChanged(schema) {
    const type = this.adEditor.viewModel.Type();
    const params = type !== 'Responsive' ?
      this.adEditor.adTypeViews[type].toObject() :
      this.adEditor.adTypeViews[type].audienceAd.crudReactComponent.current.getData();
    let current = _.pick(params, schema);
    let original = _.pick(this.adEditor.model, schema);
    if (type === 'ResponsiveSearch') { // RSA
      const pickField = ['Asset', 'PinnedField'];

      current.Headlines = _.map(current.Headlines, (headline) => {
        headline.Asset = _.omit(headline.Asset, 'Name');
        return headline;
      });
      current.Descriptions = _.map(current.Descriptions, (description) => {
        description.Asset = _.omit(description.Asset, 'Name');
        return description;
      });
      original = _.omit(original, 'NativePreference');
      original.Headlines = _.map(original.Headlines, headline => _.pick(headline, pickField));
      original.Descriptions = _.map(original.Descriptions, desc => _.pick(desc, pickField));
    } else if (type === 'Responsive') { // MMA
      const currentImageList =
        this.adEditor.adTypeViews[type].audienceAd
          .crudReactComponent.current.getFlattenedImageAssetList();
      const originalImageList = original.Images;
      if (this.hasImageChanged(currentImageList, originalImageList)) {
        return true;
      }

      current = _.omit(current, 'Images');
      original = _.omit(original, 'Images');
      current = transformMultimediaAd(_.pick(
        current,
        adTypeFieldsMapping[RECOMMENDATION_TYPES.MULTIMEDIA_ADS]
      ));

      const pickField = ['Text'];
      original.ShortHeadlines = _.map(
        original.Headlines,
        headline => _.pick(headline.Asset, pickField)
      );
      original.LongHeadlines = _.map(
        original.LongHeadlines,
        longHeadline => _.pick(longHeadline.Asset, pickField)
      );
      original.AdTexts = _.map(
        original.Descriptions,
        description => _.pick(description.Asset, pickField)
      );
      original = _.omit(original, 'Headlines', 'Descriptions');
    }

    current = _.pick(current, _.negate(_.isEmpty));
    original = _.pick(original, _.negate(_.isEmpty));
    // remove the property MobileFinalUrls if its first element is empty
    if (current.MobileFinalUrls && current.MobileFinalUrls[0] === '') {
      current = _.omit(current, 'MobileFinalUrls');
    }
    if (original.MobileFinalUrls && original.MobileFinalUrls[0] === '') {
      original = _.omit(original, 'MobileFinalUrls');
    }

    return !_.isEqual(_.omit(current, 'Id'), _.omit(original, 'Id'));
  }

  render() {
    this.$el.empty().append(template({ i18n: this.i18n }));
    this.$('.adEditor-container').prepend(this.adEditor.render().el);
    return this;
  }

  get template() { return template; }

  hasImageChanged(currentImageList, originalImageList) {
    if (currentImageList.length !== originalImageList.length) {
      return true;
    }
    // eslint-disable-next-line consistent-return
    _.each(currentImageList, (image, index) => {
      if (image.id !== originalImageList[index].Asset.Id
        || image.associationType !== originalImageList[index].Asset.SubType
        || image.src !== originalImageList[index].Asset.ImageUrl) {
        return true;
      }
    });
    return false;
  }
}
